import PageSection from "@components/PageSection";
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@components/Catalyst/table'



const PigmentData = ({ product }: { product: Queries.ProductTechInfoFragment }) => {
  if (!product?.products_colors?.pigments || (product?.products_colors?.pigments?.length ?? 0) === 0) return null;

  const pData = [...product.products_colors.pigments]
  .sort( (a, b) =>  (a?.sort ?? 1000000) - (b?.sort ?? 1000000) )
  .flatMap( ( p ) => ( p && p.pigment  ) ? p.pigment : [] )
  .filter((x, i ,a ) => a.findIndex( (p) => p.color_index_name === x.color_index_name ) === i);  // remove duplicates

  return (
    <PageSection sectionName="Pigment Detail" >

      <div className="w-screen md:w-full">
      <Table >
          <TableHead>
            <TableRow>
            <TableHeader>CI name (number)</TableHeader>

              <TableHeader>Common name</TableHeader>
              <TableHeader>Classification</TableHeader>
              <TableHeader>Chemical Description</TableHeader>

            </TableRow>
          </TableHead>
          <TableBody>

         {pData.map(
          ({ _id, color_index_name,  color_index_number, common_name, chemical_description, classification }) =>(
              <TableRow key={_id}>

                <TableCell>{`${color_index_name} (${color_index_number})`}</TableCell>

                <TableCell>{common_name ?? ""}</TableCell>
                <TableCell>{chemical_description}</TableCell>
                <TableCell>{classification ?? ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

    </PageSection>
  );
};

export default PigmentData;
